import { Component, OnInit, Input, ChangeDetectionStrategy } from '@angular/core';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Observable } from 'rxjs/Observable';
import { MaterialConfiguration } from 'app/core/components/workflow-new/material/configurations/material-configuration';
import { RxComponent } from 'app/shared/components/common/rx.component';
import { Router, ActivatedRoute } from '@angular/router';
import { Subject } from 'rxjs/Subject';
import { ReplaySubject } from 'rxjs/ReplaySubject';

@Component({
  selector: 'itpx-evaluation-multi-content-deliverable-up-to-date',
  templateUrl: './evaluation-multi-content-deliverable-up-to-date.component.html',
  styleUrls: ['../../../workflow-new/common/style.css']
})
export class EvaluationMultiContentDeliverableUpToDateComponent extends RxComponent {

  @Input() deliverable$: Observable<any>;
  @Input() conf: MaterialConfiguration;
  @Input() tileClicked$: Observable<void>;
  private tileClickedSource$ = new Subject<any>();
  private tagType: string;
  private classType: string;
  private deliverableSubject$ = new ReplaySubject<any>(1);
  private assignmentId: string;

  private state$ = new ReplaySubject(1);
  constructor(
    private router: Router,
    private route: ActivatedRoute
  ) { super(); }

  ngOnInit(): void {
    Object.assign(this, this.conf);
    this.route.params.take(1).subscribe(params => this.assignmentId = params['assignmentId']);
    this.tileClicked$.bindToLifecycle(this).subscribe(_ => { this.tileClickedSource$.next(); });
    this.deliverable$.bindToLifecycle(this).subscribe(deliverable => {
      this.state$.next({ enabled: true, type: deliverable.type, googleEmbedLink: deliverable.contents[0].googlePresentationEmbedLink });
      this.deliverableSubject$.next(deliverable);
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/core/components/evaluation/workflow_new/evaluation-multi-content-deliverable-up-to-date/evaluation-multi-content-deliverable-up-to-date.component.ts